import { RequestTypes } from '../hooks/useRequest'

export const GREEN_TOOLS_API_PREFIX = '/api/green-tools/v1/'
export const EXTENSION_API_PREFIX = '/api/extension/v1/'

export const GREEN_TOOLS_CERTIFICATES = 'my-certificates'
export const GREEN_TOOLS_ACCOUNTS = 'accounts?need_opened_only=1'
export const GREEN_GENERATORS_ACCOUNT = 'generators-certificates?account_id='
export const GREEN_GENERATOR = 'ei/generators?account_id='

export const GREEN_CONTRACTS = 'contracts/my-contracts'
export const GREEN_TOOLS_OTHER = 'ei/my-ext-instruments'
export const GREEN_TOOLS_NEW_OTHER = 'ei/new'
export const GREEN_TOOLS_REDEEMED_TO_ME = 'certificate-user-consumption'

export const ZD_LITE = 'files/zd_lite'
export const ZD_FULL = 'files/zd_full'

export const getCertificates = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_TOOLS_CERTIFICATES}`,
    method: RequestTypes.post,
}

export const getAccounts = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_TOOLS_ACCOUNTS}`,
    method: RequestTypes.get,
}

export const getGeneratorsForAccount = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_GENERATORS_ACCOUNT}`,
    method: RequestTypes.get,
}

export const getGenerators = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_GENERATOR}`,
    method: RequestTypes.get,
}

export const getContracts = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_CONTRACTS}`,
    method: RequestTypes.post,
}

export const getOther = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_TOOLS_OTHER}`,
    method: RequestTypes.post,
}

export const getNewOther = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_TOOLS_NEW_OTHER}`,
    method: RequestTypes.get,
}

export const getRedeemedToMe = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_TOOLS_REDEEMED_TO_ME}`,
    method: RequestTypes.post,
}

export const getZDLite = {
    link: `${EXTENSION_API_PREFIX}${ZD_LITE}`,
    method: RequestTypes.get,
}
export const getZDFull = {
    link: `${EXTENSION_API_PREFIX}${ZD_FULL}`,
    method: RequestTypes.get,
}

export const MONTHS_LOWER: Record<number, string> = {
    1: 'январь',
    2: 'февраль',
    3: 'март',
    4: 'апрель',
    5: 'май',
    6: 'июнь',
    7: 'июль',
    8: 'август',
    9: 'сентябрь',
    10: 'октябрь',
    11: 'ноябрь',
    12: 'декабрь',
}
